export default __webpack_public_path__ + "static/media/5.ec2c4aea.jpg";